import React from "react";
import { ArrowDown, MapPin, Mail } from "lucide-react";

export default function Hero() {
    return (
        <section
            id="top"
            data-testid="hero-section"
            className="relative pt-40 pb-28 md:pt-52 md:pb-36 overflow-hidden paper"
        >
            <div className="relative max-w-[1400px] mx-auto px-5 md:px-10">
                <div className="grid grid-cols-12 gap-6 items-end">
                    <div className="col-span-12 lg:col-span-9">
                        <p className="label-eyebrow mb-10" data-testid="hero-eyebrow">
                            — Portfolio · Consultant SEA / SMA · Paris
                        </p>

                        <h1
                            data-testid="hero-title"
                            className="font-serif text-[#0e0e0c] tracking-tight leading-[0.95]"
                            style={{
                                fontSize: "clamp(56px, 11vw, 188px)",
                                fontWeight: 300,
                            }}
                        >
                            Une croissance{" "}
                            <span className="italic-serif" style={{ fontWeight: 400 }}>
                                mesurée,
                            </span>
                            <br />
                            des chiffres{" "}
                            <span className="italic-serif" style={{ fontWeight: 400 }}>
                                qui parlent.
                            </span>
                        </h1>

                        <div className="mt-12 grid grid-cols-1 md:grid-cols-12 gap-8">
                            <p
                                data-testid="hero-pitch"
                                className="md:col-span-7 text-[#2c2c2a] text-lg leading-[1.7] max-w-2xl"
                            >
                                Quatre années à piloter des budgets médias pour des
                                marques de luxe, de formation et d'organisations à
                                impact, soutenues par une{" "}
                                <span className="italic-serif">
                                    solide expertise en développement web
                                </span>{" "}
                                (JavaScript, Angular, PHP, WordPress). Mon approche{" "}
                                <span className="italic-serif">
                                    allie la rigueur d'un développeur
                                </span>{" "}
                                à la créativité d'un stratège média — pour des
                                campagnes qui performent durablement.
                            </p>
                            <div className="md:col-span-5 md:pl-8 md:border-l md:border-[#e8e4dd] flex flex-col justify-end">
                                <p className="label-eyebrow mb-3">Marchés couverts</p>
                                <p className="font-serif text-2xl text-[#0e0e0c]">
                                    France · Italie · Espagne · Allemagne ·
                                    Belgique · Suisse
                                </p>
                            </div>
                        </div>

                        <div className="mt-14 flex flex-wrap items-center gap-4">
                            <a
                                href="#etudes"
                                data-testid="hero-cta-cases"
                                className="btn-primary"
                            >
                                Voir les études de cas
                                <ArrowDown size={14} />
                            </a>
                            <a
                                href="mailto:quentinsoulton@gmail.com"
                                data-testid="hero-cta-mail"
                                className="btn-ghost"
                            >
                                <Mail size={14} /> quentinsoulton@gmail.com
                            </a>
                        </div>

                        <div className="mt-16 flex flex-wrap items-center gap-6 text-[13px] text-[#6b6b66]">
                            <div className="flex items-center gap-2">
                                <span className="relative flex h-2 w-2">
                                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-500 opacity-60" />
                                    <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-600" />
                                </span>
                                Disponible
                            </div>
                            <div className="flex items-center gap-2">
                                <MapPin size={13} />
                                Paris, France
                            </div>
                            <div className="hidden md:block">
                                4 années d'expérience · 8+ marques accompagnées
                            </div>
                        </div>
                    </div>

                    <aside className="hidden lg:block col-span-3 self-end pb-2">
                        <div className="border-l border-[#e8e4dd] pl-6">
                            <p className="label-eyebrow mb-5">Spécialités</p>
                            <ul className="space-y-3 text-[#2c2c2a]">
                                <li className="font-serif text-xl">— SEA stratégique</li>
                                <li className="font-serif text-xl">— Social Ads</li>
                                <li className="font-serif text-xl">— Tracking &amp; data</li>
                                <li className="font-serif text-xl">— Audit de comptes</li>
                            </ul>
                        </div>
                    </aside>
                </div>
            </div>
        </section>
    );
}
